// extracted by mini-css-extract-plugin
export default {"dialog":"checkQuestion__dialog___dWS+A","form":"checkQuestion__form___txbvG","textField":"checkQuestion__textField___YKq93","actions":"checkQuestion__actions___sg2X9"};